import { render, staticRenderFns } from "./PhotoModal.vue?vue&type=template&id=1fa686af&"
import script from "./PhotoModal.vue?vue&type=script&lang=js&"
export * from "./PhotoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports